import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const mandateProgram = (programid, usergroupid, Isrepetitive, Frequency) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.GROUP_MANAGEMENT.MANADATE_PROGRAM(
      programid,
      usergroupid,
      Isrepetitive,
      Frequency
    )
  );
};

export default mandateProgram;
